// extracted by mini-css-extract-plugin
export var circle = "_al-1";
export var exitConfirmationModal = "_al-5";
export var iframe = "_al-0";
export var offline = "_al-3";
export var online = "_al-2";
export var workstationSelectError = "_al-4";